cockpitApp.directive('locationDetailsAdditional', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/location/details-additional',
    controllerAs: 'locationDetailsAdditionalCtrl',
    controller: 'locationDetailsAdditionalController'
  };
});
